export default "__VITE_ASSET___FuKLkAt__"